import React from 'react';
import { IconTile } from '../ui/index.tsx';

type IconComponent = React.ComponentType<{ size?: number; strokeWidth?: number; className?: string }>;

interface InsightSectionProps {
    icon?: IconComponent;
    title: React.ReactNode;
    children: React.ReactNode;
    className?: string;
}

/**
 * InsightSection — one beat of the standard insight narrative: a brand IconTile marker + heading,
 * then the body at full width beneath it. Used for every section (What's happening / The numbers /
 * What it means over time / Why / What to do next) so every module looks and reads the same way.
 *
 * The body is NOT indented under the title — it spans the panel's full width. In this narrow
 * (~360px) panel that extra width matters for the data tables (CashflowBridge) and longer copy;
 * the icon tile + bold title + inter-section spacing carry the hierarchy.
 */
export function InsightSection({ icon, title, children, className = '' }: InsightSectionProps) {
    return (
        <div className={className}>
            <div className="mb-2 flex items-center gap-2.5">
                <IconTile icon={icon} tone="brand" variant="solid" size="sm" />
                <h4 className="m-0 text-sm font-bold text-slate-900">{title}</h4>
            </div>
            <div className="text-sm leading-relaxed text-slate-600">{children}</div>
        </div>
    );
}

export default InsightSection;
